const messages = {
  title: "Prodajne promocije",
  desc: "Aktivno uporabljajte naše prodajne promocije z vašimi strankami. Seveda lahko stranke ponudite obe promociji. Preberite več o Garanciji pnevmatik in Drive Our Best spodaj.",
  participation: {
    title: "Zahtevajte vaše sodelovanje zdaj",
    desc: "Bi želeli implementirati eno ali več naših promocij v vaši trgovini? Potem lahko tukaj zahtevate vaše sodelovanje. Vaše podjetje bo aktivirano za promocije in prejelo bo promocijske materiale v 4 tednih za vašo prodajno kampanjo.<br/><br/>Naredite vašo izbiro:",
    request: "ZAHTEVAJ SODELOVANJE",
    success: "Hvala, vaša zahteva je bila poslana",
  },
};
export default {
  messages,
};
